import Alert from "./Alert.vue";
import { pluginify } from "./../../util";
export default pluginify(Alert);
export { Alert };
